import Exerciser381 from "../components/exercisers/Fifth/Exerciser381";
import Exerciser28 from "../components/exercisers/CM1/Exerciser28";
import Exerciser76 from "../components/exercisers/CM1/Exerciser76";
import Exerciser379 from "../components/exercisers/CM1/Exerciser379";
import Exerciser78 from "../components/exercisers/CM2/Exerciser78";
import Exerciser77 from "../components/exercisers/CM2/Exerciser77";
import Exerciser160 from "../components/exercisers/Fifth/Exerciser160";
import Exerciser159 from "../components/exercisers/Fifth/Exerciser159";
import Exerciser29 from "../components/exercisers/CM1/Exerciser29";
import Exerciser382 from "../components/exercisers/Sixth/Exerciser382";

export const activeExercisers = [
    // ---- CM1
    {
        id: 28,
        component: Exerciser28
    },
    {
        id: 29,
        component: Exerciser29
    },
    {
        id: 76,
        component: Exerciser76
    },
    {
        id: 379,
        component: Exerciser379
    },
    // ---- CM2
    {
        id: 77,
        component: Exerciser77
    },
    {
        id: 78,
        component: Exerciser78
    },
    // ---- 6e
    {
        id: 382,
        component: Exerciser382
    },
    // ---- 5e
    {
        id: 159,
        component: Exerciser159
    },
    {
        id: 160,
        component: Exerciser160
    },
    {
        id: 381,
        component: Exerciser381
    }
    // ---- 4e
    // ---- 3e
]